import React from 'react'
import Sidebar from "../components/Sidebar"

const Report = () => {
    return (
        <>
        <Sidebar/>
        
        <div className='file'>
              
             <h1>FILES PAGE</h1>
        </div>
        </>
    )
}

export default Report